import { Link } from "react-router-dom";
import { quizRegistry } from "@quizzes/_registry";

export function QuizList() {
  const quizzes = Object.values(quizRegistry);

  return (
    <div>
      <header className="mb-8">
        <span className="eyebrow">Registry</span>
        <h1 className="heading mt-1 text-3xl">Quizzes</h1>
        <p className="mt-2 max-w-2xl text-sm text-mars-white/60">
          Source of truth:{" "}
          <code className="mono rounded bg-mars-charcoal px-1.5 py-0.5 text-mars-orange">
            quizzes/_registry.ts
          </code>
          . Read-only — edit via Claude Code on the TypeScript files.
        </p>
      </header>

      <div className="overflow-hidden rounded-xl border border-mars-line">
        <table className="w-full text-sm">
          <thead className="bg-mars-charcoal">
            <tr className="text-left">
              <Th>Slug</Th>
              <Th>Title</Th>
              <Th>Questions</Th>
              <Th>Capture</Th>
              <Th />
            </tr>
          </thead>
          <tbody>
            {quizzes.length === 0 ? (
              <tr>
                <td colSpan={5} className="px-5 py-12 text-center text-mars-white/40">
                  No quizzes registered.
                </td>
              </tr>
            ) : null}
            {quizzes.map((q) => (
              <tr
                key={q.slug}
                className="border-t border-mars-line bg-mars-night transition-colors hover:bg-mars-charcoal"
              >
                <td className="mono px-5 py-4 text-mars-orange">{q.slug}</td>
                <td className="px-5 py-4 text-mars-white">{q.meta.title}</td>
                <td className="mono px-5 py-4 text-mars-white/80">{q.questions.length}</td>
                <td className="px-5 py-4 text-mars-white/60">
                  {q.capture.fields.join(", ") || "none"}
                </td>
                <td className="px-5 py-4 text-right">
                  <Link
                    to={`/quizzes/${q.slug}`}
                    className="mono text-[0.7rem] uppercase tracking-[0.16em] text-mars-orange hover:text-mars-orange-deep"
                  >
                    View &rarr;
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Th({ children }: { children?: React.ReactNode }) {
  return (
    <th className="eyebrow px-5 py-3 text-left">
      {children}
    </th>
  );
}
